import { PlaybookStatus } from '../api/playbooks/playbook.model';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const PlaybookStatusSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.PlaybookStatus}-${PlaybookStatus.active}`,
    value: PlaybookStatus.active,
    displayName: PlaybookStatus.active,
    filterType: FilterTypesEnum.PlaybookStatus,
    categoryName: FilterTypesEnum.PlaybookStatus,
  },
  {
    id: `${FilterTypesEnum.PlaybookStatus}-${PlaybookStatus.disabled}`,
    value: PlaybookStatus.disabled,
    displayName: PlaybookStatus.disabled,
    filterType: FilterTypesEnum.PlaybookStatus,
    categoryName: FilterTypesEnum.PlaybookStatus,
  },
];
